// #58 SkillRow: a required skill as a 40 px row on --card-2 (alt .skr .skn) — an optional Grip (row 113), the number,
// the skill's name, the red *Critical* pill when the skill is required, who it is assigned to (Avatars), the round
// that covers it in --text-2, and a right-hand slot (a FieldState, an action). It is the skill row, not a skeleton
// (DS #58, H-16 corrected; the skeleton is #71). The row is not a control: its hotspots sit on its Grip and its
// right-hand controls.

import type { ReactNode } from "react";
import { Pill } from "../core/Pill";
import { Avatars, type AvatarsProps } from "../core/Person";
import { cx } from "../lib/cx";
import { G1_LABELS } from "./labels";

export interface SkillRowProps {
  /** The skill's name. */
  name: ReactNode;
  /** The skill's number in the list ("#2"). */
  n?: number | undefined;
  /** Required for the role: the *Critical* pill. */
  critical?: boolean | undefined;
  /** Who it is assigned to. */
  assigned?: AvatarsProps["items"] | undefined;
  /** The round that covers it. */
  round?: ReactNode | undefined;
  /** A Grip (row 113) when the order can change. */
  grip?: ReactNode | undefined;
  right?: ReactNode | undefined;
  className?: string | undefined;
}

export function SkillRow({ name, n, critical, assigned, round, grip, right, className }: SkillRowProps) {
  return (
    <div className={cx("mc-skr", className)}>
      {grip ?? null}
      {n !== undefined ? <span className="mc-skr-n mc-mono">#{n}</span> : null}
      <span className="mc-skn">{name}</span>
      {critical ? <Pill tone="red">{G1_LABELS.critical}</Pill> : null}
      {round !== undefined && round !== null ? <span className="mc-skr-r">{round}</span> : null}
      {assigned && assigned.length > 0 ? <Avatars items={assigned} size={24} /> : null}
      {right ? <span className="mc-skr-x">{right}</span> : null}
    </div>
  );
}
